<template>
  <tbody
    class="is-size-5 has-cells-vcentered"
    v-if="search">
    <tr class="is-size-6 has-background-light">
      <td class="is-narrow">
        <span>{{ search.research_date | prettyDate }}</span>
      </td>
      <td class="is-narrow">
        <span v-if="search.lot_natures && search.lot_natures.length">
          <span
            v-for="(nature, i) in search.lot_natures"
            :key="i">
            <span v-if="i === 0">{{ nature | natureLabel }}</span>
            <span v-else>, {{ nature | natureLabel }}</span>
          </span>
        </span>
        <br>
        <span v-if="search.lot_types && search.lot_types.length">
          <span
            v-for="(type, i) in search.lot_types"
            :key="i">
            <span v-if="i === 0">{{ type | lotTypeLabel }}</span>
            <span v-else>, {{ type | lotTypeLabel }}</span>
          </span>
        </span>
        <br>
        <span v-if="search.lot_subtypes && search.lot_subtypes.length">
          <span
            v-for="(subtype, i) in search.lot_subtypes"
            :key="i">
            <span v-if="i === 0">{{ subtype | lotSubtypeLabel }}</span>
            <span v-else>, {{ subtype | lotSubtypeLabel }}</span>
          </span>
        </span>
      </td>
      <td>
        <div>
          <p>
            <span
              v-for="(state, i) in search.states"
              :key="state">
              {{ state | statesLabel }}<span v-if="i !== search.states.length - 1">, </span>
            </span>
          </p>
        </div>
      </td>
      <td>
        <div>
          <p>
            <span
              v-for="(cities, i) in search.location"
              :key="cities.pk">
              <!-- ICI je dois faire un truc au created pour afficher non pas un pk mais une data city_code ... etc -->
              {{ cities.city_code }}<span v-if="i !== search.location.length - 1">, </span>
            </span>
          </p>
        </div>
      </td>
      <td class="is-narrow">
        <span v-if="search.distance">{{ search.distance / 1000 }}</span>
      </td>
      <td class="is-narrow">
        <span>{{ search.destination | contactResearchLabel | truncateShort }}</span>
      </td>
      <td class="is-narrow">
        <div v-if="search.budget_min >= 0">
          min: {{ search.budget_min | prettyPrice }} €
        </div>
        <div v-if="search.budget_max">
          max: {{ search.budget_max | prettyPrice }} €
        </div>
        <div v-if="search.budget_max === null">
          max: NC
        </div>
      </td>
      <td class="is-narrow">
        <span v-if="search.surface_min != null && search.surface_max != null">{{ search.surface_min }}m² - {{ search.surface_max }}m²</span>
        <span v-else-if="search.surface_min != null && search.surface_max === null">{{ search.surface_min }}m² et plus</span>
        <span v-else-if="search.surface_min === null && search.surface_max != null">{{ search.surface_max }}m² et moins</span>
      </td>
      <td class="is-narrow has-text-centered is-paddingless-right">
        <display-button-list
          :data="search"
          :buttons="buttonList"
          :classes="'button is-circle is-action is-small'"
          :icon-class="'fas fa-ellipsis-v'">
        </display-button-list>
      </td>
    <!-- HB : Code ci-dessous remplacer par le composant "displayButtonList" pour profiter des tooltips intelligente -->
    <!--<td class="has-text-right is-paddingless" style="height:50px">
      <div class="dropdown is-hoverable is-right is-paddingless is-height-full">
        <div class="dropdown-trigger is-border-left is-height-full" >
          <button class="button page-header-btn is-small is-square is-action" aria-haspopup="true" aria-controls="dropdown-menu">
            <span class="is-icon"><i class="fas fa-ellipsis-v"></i></span>
          </button>
        </div>
        <div class="dropdown-menu" id="dropdown-menu" role="menu">
          <div class="dropdown-content has-text-left">
            <a @click.prevent.stop="openStock(search)" class="dropdown-item">
              <span class="icon"><i class="fal fa-eye"></i></span> Afficher résultat dans le stock
            </a>
            <a @click.prevent.stop="openSearchQuickview(search)" class="dropdown-item">
              <span class="icon"><i class="fal fa-edit"></i></span> Modifier critères de recherche
            </a>
            <a @click.prevent.stop="deleteResearch(search.pk)" class="dropdown-item">
              <span class="icon"><i class="fal fa-trash"></i></span> Annuler recherche
            </a>
          </div>
        </div>
      </div>
    </td>-->
    </tr>
    <tr
      :key="search.name"
      class="is-border-bottom">
      <td
        colspan="12"
        class="is-clipped is-paddingless row-width-actions-bar">
        <div class="columns is-gapless">
          <div class="column is-padding-small is-self-centered">
            <a
              v-if="!isOpen"
              @click.prevent.stop="openSuggestion(search)">
              <span class="title is-6 has-text-weight-normal">Lots correspondants aux critères de recherche</span>
            </a>
            <a
              v-else
              @click="isOpen = false">
              <span class="title is-6 has-text-weight-normal">Lots correspondants aux critères de recherche</span>
            </a>
          </div>
          <div class="column is-narrow is-border-left">
            <a
              v-if="!isOpen"
              @click.prevent.stop="openSuggestion(search)"
              class="page-header-btn is-small is-square">
              <span class="icon is-small"><i class="fas fa-chevron-down"></i></span>
            </a>
            <a
              v-else
              @click="isOpen = false"
              class="page-header-btn is-small is-square">
              <span class="icon is-small"><i class="fas fa-times"></i></span>
            </a>
          </div>
        </div>
      </td>
    </tr>
    <tr
      v-if="isOpen"
      class="is-border-bottom">
      <td
        colspan="12"
        class="is-clipped is-paddingless"
        v-if="!loading && totalLots !== 0">
        <table class="table is-fullwidth is-marginless-bottom is-striped-v has-actionsontd">
          <thead>
            <tr class="">
              <th class="is-border-bottom">
                <span>Statut</span>
              </th>
              <th class="is-border-bottom">
                <span>Lot</span>
              </th>
              <th class="is-border-bottom">
                <span>Programme</span>
              </th>
              <th class="is-border-bottom">
                <span>Nature</span>
              </th>
              <th class="is-border-bottom">
                <span>Type</span>
              </th>
              <th class="is-border-bottom">
                <span>Caractéristique</span>
              </th>
              <th class="is-border-bottom">
                <span>Surface</span>
              </th>
              <th class="is-border-bottom">
                <span>CP</span>
              </th>
              <th class="is-border-bottom">
                <span>Dispositif</span>
              </th>
              <th class="is-border-bottom">
                <span>Prix</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="lot in lotsList"
              :key="lot.pk"
              class="is-size-6">
              <td class="is-narrow is-paddingless has-text-centered">
                <span
                  class="dot tooltip is-tooltip-right"
                  :data-tooltip="lot.status|statusLabel"
                  :class="statusColors(lot.status)"></span>
              </td>
              <td class="is-paddingless">
                <router-link
                  class="is-padding-right-small is-padding-left-xsmall is-height-full columns is-vcentered is-cell-hoverable"
                  :to="{name: 'LotVue', params: {id: lot.pk}}">
                  <b>{{ lot.ref || '-' | truncateShort }}</b>
                </router-link>
              </td>
              <router-link
                class="is-cell-hoverable"
                :to="{name: 'ProgramVue', params: {id: lot.program.pk}}"
                tag="td">
                <a :title="lot.program.name">
                  <span class="is-size-6 has-text-grey">
                    {{ lot.program.name | truncate(30) }}
                  </span>
                </a>
              </router-link>
              <td>
                <span v-if="lot.nature">{{ lot.nature | natureLabel }}</span>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="lot.lot_type">{{ lot.lot_type | lotTypeLabel }}</span>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="lot.lot_subtype && lot.lot_subtype.length">
                  <span
                    v-for="(subtype, i) in lot.lot_subtype"
                    :key="i">
                    <span v-if="i > 0">, {{ subtype | lotSubtypeLabel }}</span>
                    <span v-else>{{ subtype | lotSubtypeLabel }}</span>
                  </span>
                </span>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="lot.surface">{{ lot.surface|prettyPrice }} m²</span>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="lot.program.address && lot.program.address.zip_code">
                  {{ lot.program.address.zip_code || '' }}
                </span>
                <span v-else>-</span>
              </td>
              <td>
                <span
                  v-if="lot.tax_dispositifs && lot.tax_dispositifs.length > 0"
                  :title="lot.tax_dispositifs | prettyTaxDispositifs(taxDispositifsData)">
                  {{ lot.tax_dispositifs | prettyTaxDispositifs(taxDispositifsData) | truncate }}
                </span>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="lot.sale_price_ttc">{{ lot.sale_price_ttc | prettyPrice }} €</span>
                <span v-else>-</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="is-fullwidth has-text-centered is-padding-xsmall is-cell-hoverable has-cursor-pointer"
          @click="openStock(search)">
          <i class="fas fa-eye"></i> AFFICHER LA SUITE  ({{ lotsList.length }} lots sur {{ totalLots }} )
        </div>
      </td>
      <td
        colspan="6"
        class="is-clipped"
        v-else-if="!loading && totalLots === 0">
        <em><b>Aucun lot correspondant à la recherche</b></em>
      </td>
      <td
        v-else
        colspan="6"
        class="is-clipped"
        style="height: 100px; width: 100%;">
        <spinner-round
          :is-loading="loading"
          class="column is-relative"
          style="top: -10px; transform: translateY(-50%);"></spinner-round>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { DefaultValues } from '@/mixins'

export default {
  name: 'ContactSearchesRow',
  filters: {
    addressArray (value) {
      let address = []
      if (value && value.length) {
        value.forEach(x => address.push(`${x.state} (${x.state_code}) `))
        return address.join(' /\n')
      }
    }
  },
  mixins: [DefaultValues],
  props: {
    contact: Object,
    source: Object,
    index: Number
  },
  data () {
    return {
      isOpen: false,
      lotsList: [],
      loading: false,
      loadingLots: false,
      lotsTotalPage: 0,
      sortBy: {},
      lotsCurrentPage: 1,
      totalLots: 0,
      buttonList: [
        {
          icon: 'fa-eye',
          text: 'Afficher résultat dans le stock',
          action: (id) => {
            this.openStock(this.search)
          },
          display: (search) => { return true }
        },
        {
          icon: 'fa-edit',
          text: 'Modifier critères de recherche',
          action: (id) => {
            this.openSearchQuickview(this.search)
          },
          display: (search) => { return true }
        },
        {
          icon: 'fa-trash',
          text: 'Annuler recherche',
          action: (id) => {
            this.deleteResearch(this.search.pk)
          },
          display: (search) => { return true }
        }
      ]
    }
  },
  computed: {
    search () {
      return this.source
    },
    contactArea () {
      return this.contact
    }
    // lotTypes () {
    //   let types = this.search.lot_types.slice().filter(x => !x.match(/duplex/) && !x.match(/bis/))
    //   types = uniq(types)
    //   if (types.length > 1) {
    //     return `Du ${this.$options.filters.lotTypeLabel(types[0])} au ${this.$options.filters.lotTypeLabel(types[types.length - 1])}`
    //   } else {
    //     return this.$options.filters.lotTypeLabel(types[0])
    //   }
    // }
  },
  watch: {
    search (v) {
      if (v && (this.index === 0 || this.isOpen)) {
        this.openSuggestion(v)
      }
    }
  },
  created () {
    this.$nextTick(() => {
      if (this.index === 0) this.openSuggestion(this.source)
    })
  },
  methods: {
    changePage (v) {
      this.lotsCurrentPage = v
      this.$nextTick(() => {
        this.getLots(this.search)
      })
    },
    statusColors (val) {
      const COLORS = {
        available: 'has-background-available',
        optioned: 'has-background-optioned',
        sold: 'has-background-sold',
        draft: 'has-background-draft',
        archived: 'has-background-draft',
        reserved: 'has-background-reserved',
        pre_reserved: 'has-background-info'
      }
      return COLORS[val]
    },
    deleteResearch (id) {
      this.$emit('deleteResearch', id)
    },
    openSearchQuickview (search) {
      this.$emit('openSearchQuickview', { item: search })
    },
    openStock (search) {
      let params = {
        destination: search.destination,
        state_code: search.states && search.states.length ? search.states : null,
        nature: search.lot_natures,
        lot_type: search.lot_types,
        contact_location: search.location,
        contact_distance: search.distance ? search.distance / 1000 : null,
        lot_subtype: search.lot_subtypes,
        sale_price_ttc__gte: search.budget_min,
        sale_price_ttc__lte: search.budget_max
      }
      if (search.surface_min) {
        params.surface__gte = search.surface_min
      }
      if (search.surface_max) {
        params.surface__lte = search.surface_max
      }
      if (this.contact.shared && this.currentUser.account.pk !== this.contact.account.pk) {
        params.promoteur = [this.contact.account.pk]
      }
      if (params.sale_price_ttc__gte === 0) params.sale_price_ttc__gte = null
      if (this.contactArea) params.contact_search_area = this.contactArea.search_area

      if (params.sale_price_ttc__lte === 0) params.sale_price_ttc__lte = null
      this.$router.push({ name: 'LotList', params })
    },
    openSuggestion (e) {
      this.getLots(e)
      this.$nextTick(() => {
      })
      this.isOpen = true
    },
    async getLots (search, query) {
      this.loading = true
      let params = {
        destination: search.destination,
        state_code: search.states && search.states.length ? search.states : null,
        nature: search.lot_natures,
        lot_type: search.lot_types,
        contact_distance: search.distance ? search.distance / 1000 : null,
        lot_subtype: search.lot_subtypes,
        sale_price_ttc__gte: search.budget_min,
        sale_price_ttc__lte: search.budget_max,
        lot__status: ['available', 'optioned', 'pre_reserved'],
        per_page: 15,
        page: this.lotsCurrentPage,
        ...query
      }
      if (search.location && search.location.length) {
        params.contact_location = []
        search.location.forEach(item => {
          params.contact_location.push(item.pk)
        })
      } else {
        params.distance = null
      }
      if (search.surface_min) {
        params.surface__gte = search.surface_min
      }
      if (search.surface_max) {
        params.surface__lte = search.surface_max
      }
      if (this.contact.shared && this.currentUser.account.pk !== this.contact.account.pk) {
        params.promoteur = this.contact.account.pk
      }
      if (this.contactArea) {
        params.contact_search_area = this.contactArea.search_area
      }
      try {
        const { data } = await this.$api.get(this.$resources.STOCK_LOT, params)
        this.loading = false
        this.lotsList = data.items
        this.loadingLots = false
        this.lotsTotalPage = data.pages
        this.lotsCurrentPage = data.page
        this.totalLots = data.count
      } catch (e) {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="sass">
.fullwidth
  width: 100%
</style>
